"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneWayDateEditor = void 0;
const react_1 = __importDefault(require("react"));
const dateTime_1 = require("../../../../utils/dateTime");
const From_1 = require("../../../Form/Field/Date/From");
const ReturnWayDateEditor_1 = require("./ReturnWayDateEditor");
const OneWayDateEditor = (props) => {
    const { departing } = props;
    const departingProps = {
        value: departing.value,
        setValue: departing.onValue,
        error: departing.error,
        modificators: departing.modifiers,
        label: ReturnWayDateEditor_1.departingLabel,
        name: 'departing',
        restrictions: {
            disablePastDays: true,
            pastYearsCount: dateTime_1.bookingPastYearsCount,
            nextYearsCount: dateTime_1.bookingNextYearsCount,
        },
    };
    return (react_1.default.createElement(From_1.FormFieldFromDate, { ...departingProps }));
};
exports.OneWayDateEditor = OneWayDateEditor;
//# sourceMappingURL=OneWayDateEditor.js.map